import React, { Suspense, useEffect, useState } from "react";
import ListingImages from "../UtilsListingsComponent/ListingImages";
import useTranslation from "next-translate/useTranslation";
import ListingDetails from "../UtilsListingsComponent/ListingDetails";
import style from "./style.module.css";
import ListingDescription from "../UtilsListingsComponent/ListingDescription";
import { buildListingUrl } from "../ListingsRouterUrlHelper";
import $ from "utils/selectors";
import ContactAgence from "components/v3/Listings/ListingFullDisplay/components/contactAnnonce/ContactAgence";

function index({
  listing,
  defaultLiked,
  searchPayload,
  initialSeachPayload,
  mapVsList,
  priority,
}: {
  searchPayload?: any;
  initialSeachPayload?: any;
  listing: any;
  defaultLiked: boolean;
  mapVsList: any;
  priority?: any;
}) {
  const { t, lang } = useTranslation("annonceAchat");
  const [showDesc, setShowDesc] = useState<boolean>(false);

  const [showContactAgence, setShowContactAgence] = useState<boolean>(false);

  const contactAgenceHandler = () => {
    setShowContactAgence(!showContactAgence);
  };

  useEffect(() => {
    if (window.innerWidth < 990) {
      if (showContactAgence) {
        $("#search_form_annonce").attr("style", `z-index : 0`);
        $("body").css("height", "100%");
        $("body").css("overflow", "hidden");
      } else {
        $("#search_form_annonce").attr("style", `z-index : 10`);
        $("body").css("height", "auto");
        $("body").css("overflow", "scroll");
      }
    }
  }, [showContactAgence]);
  return (
    <>
      {showContactAgence ? (
        <Suspense fallback={<></>}>
          <ContactAgence
            t={t}
            listing={listing}
            agence={listing?.agence}
            contactAgenceHandler={contactAgenceHandler}
            lang={lang}
          />
        </Suspense>
      ) : null}

      <a
        className={style.listingCard}
        href={buildListingUrl(listing, lang, null, null, mapVsList, true)}
        onClick={(e) => {
          e.preventDefault();

          window.open(
            buildListingUrl(
              listing,
              lang,
              initialSeachPayload,
              searchPayload,
              mapVsList
            )
          );
        }}
        target="_blank"
      >
        <div className={style.listingImages}>
          <ListingImages
            priority={priority}
            listing={listing}
            t={t}
            lang={lang}
            showDesc={showDesc}
            mapVsList={mapVsList}
          />
        </div>
        <div className={style.listingDetails}>
          <ListingDetails
            lang={lang}
            listing={listing}
            t={t}
            defaultLiked={defaultLiked}
          />
          <ListingDescription
            listing={listing}
            showDesc={showDesc}
            setShowDesc={setShowDesc}
            contactAgenceHandler={contactAgenceHandler}
          />
        </div>
      </a>
    </>
  );
}

export default index;
